'use client'
import React, { memo } from 'react'
import styles from './styles.module.scss'
import { LoadingSpinner } from '../Loaders'

interface LoadMoreButtonProps {
  onClick?: () => void
  classes?: any
  children: React.ReactNode
  loading?: boolean
}

const LoadMoreButton = ({
  onClick,
  classes,
  children,
  loading = false,
}: LoadMoreButtonProps) => (
  <div
    onClick={onClick}
    className={`${styles.loadMoreButtonWrapper} ${classes} ${
      loading ? styles.loading : ''
    } `}
  >
    <div className={styles.loadMoreButton}>{children}</div>
    {loading && (
      <div className={styles.spinnerContainer}>
        <LoadingSpinner size="sm" />
      </div>
    )}
  </div>
)

export default memo(LoadMoreButton)
